import { render, staticRenderFns } from "./AccountTypeForm.vue?vue&type=template&id=d688e2c4&scoped=true&"
import script from "./AccountTypeForm.vue?vue&type=script&lang=js&"
export * from "./AccountTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d688e2c4",
  null
  
)

export default component.exports